// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1rdsN","header":"PatientQuestionnaire_header__1y7VW","info":"PatientQuestionnaire_info__1Kt_t"};